import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import NewWorkInstructionFormContainer from './new_work_instruction_form_container'

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "auto",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function SimpleModal({
    closeModal, modalTitle, submitForm}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <div className="flex-apart">
                    {/* <h2 id="simple-modal-title">{modalTitle}</h2> */}
                    <i onClick={closeModal} style={{ padding: ".3125em" }} className="fa fa-times x-button" aria-hidden="true"></i>
                </div>
                <NewWorkInstructionFormContainer
                    closeModal={closeModal}
                    submitForm={submitForm} />
            </div>
        </Modal>
    );
}
